import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/team/')({
  component: () => <PageStub title="Team" description="Team overview and management" />,
});
